import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/no_data1.png'
import _imports_1 from '@/assets/image/exten-install-header.png'


const _withScopeId = n => (_pushScopeId("data-v-bb125a38"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-grid-block"
}
const _hoisted_2 = { class: "list-grid" }
const _hoisted_3 = {
  key: 1,
  class: "noDataBox flex-cen flex-ter"
}
const _hoisted_4 = { class: "noResult flex-col flex-ter" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no_data1",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "tips" }
const _hoisted_7 = { class: "list-page flex-end" }
const _hoisted_8 = { class: "extenIntall" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_10 = { class: "contentBox flex-col flex-bwn" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "mt_4" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "text-rt mt_10 commit" }

import { Ref, ref, toRef, watch, reactive, computed } from 'vue'
import { getTranslationText } from '@/apis/common'
import GoodsItem from '@/components/common/GoodsItem.vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import { t } from '@/plugins/i18n'
import gbk from 'gbk-encode'
import { isJA, isKO, isEN, useRtfix, useSite } from '@/store'
import { ElMessage } from 'element-plus'

interface Item {
  [key: string]: any
}

export default /*#__PURE__*/_defineComponent({
  props: ['pageNum', 'pageSize', 'data', 'banner'],
  emits: ['update:pageNum', 'update:pageSize'],
  setup(__props, { emit }) {

const props = __props
const { encode } = gbk


const data = toRef(props, 'data')
const store = useStore()
const route = useRoute()
const router = useRouter()

const buss = reactive(store.state.bussiness)

const query = computed(() => route.query)

const extUrl = computed(() => `https://s.theckb.com/${useSite()}/d2c/iframe/plugin`)

// 插件安装弹窗
const extendShow = ref(false)

// 跳转站外翻译
const goToOutSite = (ext: boolean) => {
  // 插件判断
  if ((!store.getters.isInstall) && ext) {
    extendShow.value = true
    return
  }
  const { sortType, startPrice, endPrice, imageUrl, langType, keyword, productCode } = query.value

  const arr: any = []
  const url = buss.externalLinks[buss.platformType]

  if (['VC', 'WS'].includes(buss.platformType) && isEN()) {
    ElMessage.error('Error. Please contact Customer Service.')
    return
  }
  const key = 'keywords='
  arr.push(
    'sortType=' + sortType,
    'priceStart=' + startPrice,
    'priceEnd=' + endPrice
  )
  if (imageUrl) {
    window.postMessage({
      cmd: 'uploadImg',
      imgData: { src: imageUrl }
    }, '*')
    return
  }
  const text = tarnsTypeToKeyword() || keyword
  const formData = {
    from: tarnsTypeToKeyword() ? 'ja' : useSite(),
    to: 'zh',
    text: text
  }
  getTranslationText(formData).then((res: any) => {
    if (res.code === '0') {
      if (res.data === '') {
        arr.unshift(key + encodeKeyword(keyword))
      } else {
        arr.unshift(key + encodeKeyword(res.data))
      }
    } else {
      arr.unshift(key + encodeKeyword(keyword))
    }
    window.open(url + arr.join('&'))
  })
}

const tarnsTypeToKeyword = () => {
  // eslint-disable-next-line space-before-function-paren
  function flat(arr: any) {
    return arr.reduce((res: any, i: any) => {
      return res.concat((i.children && i.children.length) ? flat(i.children) : i)
    }, [])
  }
  const fastCates = flat(buss.fastCates[buss.schannel || '0'])
  const fastCatesItem = fastCates.filter((v: any) => v.productCategoryFrontendId === query.value.productCategoryFrontendId)[0]
  return fastCatesItem && fastCatesItem?.cateNameJp
}

const goToAM = () => {
  store.commit('bussiness/platformType', 'AM')
  const keyword = route.query.keyword
  buss.keyword = keyword
  const query: any = {
    ...route.query,
    schannel: 2,
    platformType: 'AM',
    keyword: keyword
  }
  router[route.name?.toString().includes('list') ? 'replace' : 'push'](
    useRtfix('list', { query })
  )
}

// 如果是跳1688就encode
const encodeKeyword = (text: any) => {
  console.log(buss.productCategoryFrontendIdNameZh)
  if (buss.productCategoryFrontendIdNameZh === undefined) {
    buss.productCategoryFrontendIdNameZh = ''
  }
  return encode(text + ' ' + buss.productCategoryFrontendIdNameZh)
}

// 暂不安装
const cancel = () => {
  extendShow.value = false
}

// 去安装
const toInstall = () => {
  let url = 'https://chrome.google.com/webstore/detail/kaeru%E3%83%84%E3%83%BC%E3%83%ABthe%E7%9B%B4%E8%A1%8C%E4%BE%BF/cbdgkflbadceflcbbogjkldbnjddnhbl?hl=jahttps://chrome.google.com/webstore/detail/kaeru%E3%83%84%E3%83%BC%E3%83%ABthe%E7%9B%B4%E8%A1%8C%E4%BE%BF/cbdgkflbadceflcbbogjkldbnjddnhbl?hl=ja'
  // 韩国为国际化插件
  if (!isJA()) {
    url = `https://chrome.google.com/webstore/detail/the-ckb-easybuy/pdafojilkicifncfkalgilcpcnejebce/related?hl=${useSite()}`
  }
  window.open(url, '_blank')
}

const list: Ref<Item[]> = ref([])
const total: Ref<number> = ref(0)

watch(data, (v) => {
  list.value = v.records
  v.total && (total.value = v.total)
  console.log(!store.getters.isLogin && total.value > 5)
})

// item不喜欢操作回调
const itemUnlike = (productCode: string) => {
  const index = list.value.findIndex((item) => item.productCode === productCode)
  list.value.splice(index, 1)
}

const currentChange = (event: any) => {
  const el = document.querySelector('#app .el-scrollbar__wrap')
  el && el.scroll(0, 0)
  emit('update:pageNum', event)
}

const sizeChange = (event: any) => {
  const el = document.querySelector('#app .el-scrollbar__wrap')
  el && el.scroll(0, 0)
  emit('update:pageNum', 1)
  emit('update:pageSize', event)
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (total.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
              return (_openBlock(), _createBlock(GoodsItem, {
                key: item.productCode,
                item: item,
                showChannel: 1,
                onUnlike: itemUnlike
              }, null, 8, ["item"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (total.value == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('暂无相关搜索结果')), 1),
            (_unref(route).query.keyword)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goToOutSite(true))),
                  class: "toOutSite flex-cen flex-ter"
                }, _toDisplayString(_unref(t)('去站外搜更多')), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "prev,pager,next,sizes",
        currentPage: __props.pageNum,
        "page-size": __props.pageSize,
        total: total.value,
        onCurrentChange: _cache[1] || (_cache[1] = ($event: any) => (currentChange($event))),
        onSizeChange: _cache[2] || (_cache[2] = ($event: any) => (sizeChange($event)))
      }, null, 8, ["currentPage", "page-size", "total"]),
      _createVNode(_component_el_dialog, {
        "append-to-body": "",
        showClose: false,
        "model-value": extendShow.value,
        width: "500px",
        "custom-class": "extenIntallDialog",
        onClose: _cache[3] || (_cache[3] = ($event: any) => (extendShow.value = false)),
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, _toDisplayString(_unref(t)('监测到您当前尚未安装KAERU插件，【站外搜】功能需要配合KAERU插件才可正常使用哦。')), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_unref(t)('什么是KAERU插件？')) + " ", 1),
                  _createElementVNode("a", {
                    href: _unref(extUrl),
                    target: "_blank"
                  }, _toDisplayString(_unref(extUrl)), 9, _hoisted_13)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_button, {
                  type: "default",
                  onClick: cancel,
                  class: "footer-btn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('暂不安装')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: toInstall,
                  class: "footer-btn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('去安装')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["model-value"])
    ]),
    (total.value > 0)
      ? _renderSlot(_ctx.$slots, "suggest", { key: 2 })
      : _createCommentVNode("", true)
  ], 64))
}
}

})